<template>
  <div class="toast-container">
    <toast-message-item
      v-for="item in items"
      :key="item.key"
      :data="item"
    />
  </div>
</template>

<script>
const ToastMessageItem = () => import("@/blocks/common/ToastMessageItem.vue")

export default {
  name: "ToastMessages",

  components: {
    ToastMessageItem
  },

  computed: {
    items() {
      return this.$store.getters["toasts/get"]
    }
  }
}
</script>
